export var diamondBackground = {right:'$_1G66v',left:'$_1FxQR'};